import { AppThunk } from "../store";

export const setFilter =
  (filter: any): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "SET_FILTER",
      filter,
    });
  };

export const removeFilter = (): AppThunk => (dispatch) => {
  dispatch({
    type: "REMOVE_FILTER",
  });
};

export const startLoading = (): AppThunk => (dispatch) => {
  dispatch({
    type: "LOADING_START",
  });
};

export const stopLoading = (): AppThunk => (dispatch) => {
  dispatch({
    type: "LOADING_END",
  });
};
